import { render, staticRenderFns } from "./workshop-change.vue?vue&type=template&id=151278f0&scoped=true&"
import script from "./workshop-change.vue?vue&type=script&lang=js&"
export * from "./workshop-change.vue?vue&type=script&lang=js&"
import style0 from "./workshop-change.vue?vue&type=style&index=0&id=151278f0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151278f0",
  null
  
)

export default component.exports